/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetClass } from './AssetClass';
import {
    AssetClassFromJSON,
    AssetClassFromJSONTyped,
    AssetClassToJSON,
} from './AssetClass';
import type { AssetType } from './AssetType';
import {
    AssetTypeFromJSON,
    AssetTypeFromJSONTyped,
    AssetTypeToJSON,
} from './AssetType';

/**
 * 
 * @export
 * @interface AssetInfo
 */
export interface AssetInfo {
    /**
     * 
     * @type {string}
     * @memberof AssetInfo
     */
    sId: string;
    /**
     * 
     * @type {string}
     * @memberof AssetInfo
     */
    scId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetInfo
     */
    symbol?: string;
    /**
     * 
     * @type {AssetClass}
     * @memberof AssetInfo
     */
    assetClass?: AssetClass;
    /**
     * 
     * @type {AssetType}
     * @memberof AssetInfo
     */
    assetType?: AssetType;
    /**
     * 
     * @type {string}
     * @memberof AssetInfo
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssetInfo
     */
    isActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AssetInfo
     */
    contractMultiplier?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetInfo
     */
    priceMultiplier?: number;
}



/**
 * Check if a given object implements the AssetInfo interface.
 */
export function instanceOfAssetInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sId" in value;

    return isInstance;
}

export function AssetInfoFromJSON(json: any): AssetInfo {
    return AssetInfoFromJSONTyped(json, false);
}

export function AssetInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sId': json['s_id'],
        'scId': !exists(json, 'sc_id') ? undefined : json['sc_id'],
        'symbol': !exists(json, 'symbol') ? undefined : json['symbol'],
        'assetClass': !exists(json, 'asset_class') ? undefined : AssetClassFromJSON(json['asset_class']),
        'assetType': !exists(json, 'asset_type') ? undefined : AssetTypeFromJSON(json['asset_type']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'isActive': !exists(json, 'is_active') ? undefined : json['is_active'],
        'contractMultiplier': !exists(json, 'contract_multiplier') ? undefined : json['contract_multiplier'],
        'priceMultiplier': !exists(json, 'price_multiplier') ? undefined : json['price_multiplier'],
    };
}

export function AssetInfoToJSON(value?: AssetInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        's_id': value.sId,
        'sc_id': value.scId,
        'symbol': value.symbol,
        'asset_class': AssetClassToJSON(value.assetClass),
        'asset_type': AssetTypeToJSON(value.assetType),
        'description': value.description,
        'is_active': value.isActive,
        'contract_multiplier': value.contractMultiplier,
        'price_multiplier': value.priceMultiplier,
    };
}

